module.exports = __webpack_public_path__ + "static/media/pickup.eb177f8b.svg";